import React, { FunctionComponent } from "react";
import { IIconProps } from "../icon";

export const EmojiNormal: FunctionComponent<IIconProps> = (props) => {
  const { color, outlined, ...rest } = props;
  return (
    <svg viewBox="0 0 56 56" {...rest}>
      <g
        id="Desktop"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g id="20f-Herz-Omega3-Demo" transform="translate(-493.000000, -770.000000)" stroke="#222222" strokeWidth="3">
          <g id="Group" transform="translate(495.000000, 772.000000)">
            <circle id="Oval" cx="26" cy="26" r="26"></circle>
            <path
              d="M17,18 C17.5522847,18 18,18.4477153 18,19 C18,19.5522847 17.5522847,20 17,20 C16.4477153,20 16,19.5522847 16,19 C16,18.4477153 16.4477153,18 17,18"
              id="Path"
            ></path>
            <path
              d="M35,18 C35.5522847,18 36,18.4477153 36,19 C36,19.5522847 35.5522847,20 35,20 C34.4477153,20 34,19.5522847 34,19 C34,18.4477153 34.4477153,18 35,18"
              id="Path"
            ></path>
            <path
              d="M37,33 C34.5445098,36.7491685 30.4179854,39 26,39 C21.5820146,39 17.4554902,36.7491685 15,33"
              id="Path"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
};
